import { API } from '../../../../config';
import { errorHandler } from '../../auth/errorAction';

export const unmountListVillages = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_VILLAGE'})
}

export const unmountDetailVillages = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_VILLAGE'})
}

export const unmountMasterVillages = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_VILLAGE'})
}

export const listVillages = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_VILLAGE' })
  return API.GET('/village/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_VILLAGE_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_VILLAGE_FAILED' }), 
    ))
  })
}

export const detailVillage = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_VILLAGE' })
  const params = {
    'id': id
  }
  API.GET('/village/getById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_VILLAGE_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_VILLAGE_FAILED' }), 
      ))
    )
  })
}

export const masterVillages = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_VILLAGE' })
  return API.GET('/village/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_VILLAGE_SUCCESS', 
      payload: { data: response.data }
    })
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_VILLAGE_FAILED' }), 
    ))
  })
}

export const villageBySubDistrict = (id, successCB, failedCB) => async (dispatch) => {
  const params = { 'id': id }
  API.GET('/village/getBySubDistrictId', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(err))
    )
  })
}

export const createVillage = (value, successCB, failedCB) => () => {
  API.POST_NO_PARAMS('/village/add', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const editVillage = (value, successCB, failedCB) => () => {
  API.POST_NO_PARAMS('/village/update', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const enableVillage = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/village/enable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const disableVillage = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/village/disable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}